import { ApiServices } from "services/apiServices";
import {
  FormatConstants,
} from "services/keyConstants";
import { showToast } from "services/utils";
import * as url from "./urlHelper";
import { getMasterDocDataByKey } from "services/ReduxUtils";

export const createCalibrationPlan = async (id) => {
  try {
    const masterDocData = await getMasterDocDataByKey(
      {
        defaultName: FormatConstants.MAMOFEQUIPMENT.CALIBRATION_PLAN
      }
    );
    const reqObj = {
      id: id,
      masterDocId: masterDocData?.masterDocId,
      documentName: FormatConstants.MAMOFEQUIPMENT.CALIBRATION_PLAN,
    };
    const uri = url?.CREATE_CALIBRATION_PLAN;
    const result = await ApiServices.callServicePostWithBodyData(uri, reqObj);
    showToast(result);
  } catch (error) {
    console.error(error);
  }
};


// make array of object for equipment name and id merge
export const transformEquipmentData = (equipmentArray) => {
  return equipmentArray?.map((item) => {
    const { equipmentName, equipmentId } = item || {};
    return {
      name: `${equipmentName}-${equipmentId}`,
      _id: item?._id,
    };
  });
};